export default "__VITE_ASSET__IB0zrQjY__"